module.exports = __webpack_public_path__ + "static/screenshot1-48fd098056267b45d36544374e09d560.png";